export default __webpack_public_path__ + "static/media/m2.31c0ad55.jpg";